export const SEARCH_FACET_REDUX_KEY = 'searchFacets';
export const SEARCH_FILTER_CONFIG_REDUX_KEY = 'searchFilterConfig';
export const LOCATION_FILTER_REDUX_KEY = 'locationFilter';
export const PRODUCT_LABEL_REDUX_KEY = 'productLabel';
export const SEARCH_ITEMS_REDUX_KEY = 'searchItems';
export const SEARCH_CATEGORY_REDIRECTION_KEY = 'searchCategoryRedirection';
export const MART_SEARCH_ITEMS_REDUX_KEY = 'martSearchItems';
export const MART_SEARCH_FACET_REDUX_KEY = 'martSearchFacet';
export const MART_NSRP_RCMD_REDUX_KEY = 'martNsrpRcmd';
